import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { injectable } from "inversify";
import { injectToken } from "inversify-token";
import { YinzCamAPIResponse } from "yinzcam-api";
import {profile} from '../../../../static/dummy/yinzchat_dummy';
import { YinzCamSignonServerToken } from "yinzcam-signon";
import { YinzCamAppServerToken } from "yinzcam-appserver";
@injectable()
export class YinzCamSignonProfileSegment extends CardsDataSourceBase {
  //  public constructor(@injectToken(YinzCamSignonServerToken) server) {
  public constructor(@injectToken(YinzCamAppServerToken) server) { //This is test.
    super({ server })
  }

  protected processResponse(response: YinzCamAPIResponse): object | any[] {
    let data = response?.data as any;
    return data;
    // return profile;
  }
}
